// import history from '../../history';

import types from '../../constants';
import auth from '../../auth';

export function fetchCompanies() {
  return async (dispatch) => {
    dispatch({ type: types.USER_COMPANIES_LOADING_START });
    fetch('/api/companies', {
      method: 'GET',
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
    .then((response) => {
      if (response.status === 403 || response.status === 401) {
        auth.logoutAndRedirect();
        throw new Error('Not authenticated.');
      }

      return response.json();
    })
    .then((data) => {
      dispatch({
        type: types.USER_COMPANIES_FETCH,
        payload: data.companies,
      });
      dispatch({ type: types.USER_COMPANIES_LOADING_END });
    });
  };
}

export function fetchUser(userId) {
  return async (dispatch) => {
    dispatch({ type: types.USER_LOADING_START });
    fetch(`/api/users/${userId}`, {
      method: 'GET',
      headers: {
        pragma: 'no-cache',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => {
        if (response.status === 403 || response.status === 401) {
          auth.logoutAndRedirect();
          throw new Error('Not authenticated.');
        }

        return response.json();
      })
      .then((data) => {
        data.user.password = '';

        dispatch({
          type: types.USER_FETCH,
          payload: data.user,
        });
        dispatch({ type: types.USER_LOADING_END });
      });

    return true;
  };
}

export function saveUser(user, id) {
  return async (dispatch) => {
    let url = '/api/users';
    if (id) {
      url += `/${id}`;
    }
    const method = id ? 'PUT' : 'POST';

    if (user.password === '') {
      delete user.password;
    }

    dispatch({ type: types.USER_LOADING_START });
    return fetch(url, {
      method,
      body: JSON.stringify(user),
      headers: {
        pragma: 'no-cache',
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => {
        const json = response.json();

        if (response.status === 403 || response.status === 401) {
          auth.logoutAndRedirect();
          return Promise.reject('Not authenticated.');
        }

        if (response.status !== 200) {
          return json.then(Promise.reject.bind(Promise));
        }

        return response;
      })
      .then(() => {
        dispatch({ type: types.USER_LOADING_END });
        // history.goBack();
      })
      .catch((err) => {
        let dispatchedError;
        if (err.error && err.error.type === 'validation') {
          dispatchedError = err.error.errors;
        } else {
          dispatchedError = { general: 'An internal error has occured.' };
        }

        dispatch({
          type: types.USER_SET_ERROR,
          payload: dispatchedError,
        });
        dispatch({ type: types.USER_LOADING_END });
        throw err;
      });
  };
}

export function deleteUser(id) {
  return async (dispatch) => {
    dispatch({ type: types.USER_LOADING_START });
    return fetch(`/api/users/${id}`, {
      method: 'DELETE',
      headers: {
        pragma: 'no-cache',
        'Content-Type': 'application/json',
        Accept: 'application/json',
        Authorization: localStorage.token,
      },
    })
      .then((response) => {
        if (response.status === 403 || response.status === 401) {
          auth.logoutAndRedirect();
          return Promise.reject('Not authenticated.');
        }

        return response;
      })
      .then(() => {
        dispatch({ type: types.USER_LOADING_END });
        // history.push('/users');
      })
      .catch((err) => {
        let dispatchedError;
        if (err.error && err.error.type === 'validation') {
          dispatchedError = err.error.errors;
        } else {
          dispatchedError = { general: 'An internal error has occured.' };
        }

        dispatch({
          type: types.USER_SET_ERROR,
          payload: dispatchedError,
        });
        dispatch({ type: types.USER_LOADING_END });
      });
  };
}

export function changeForm(field, value) {
  return async (dispatch) => {
    if (field == 'user') {
      value = value.toLowerCase();
    }
    dispatch({
      type: types.USER_CHANGE_FORM,
      payload: { field, value },
    });
  };
}

export function clearUser() {
  return async (dispatch) => {
    dispatch({ type: types.USER_CLEAR });
  };
}

export function setError(err) {
  return async (dispatch) => {
    dispatch({
      type: types.USER_SET_ERROR,
      payload: err,
    });
  };
}


export function setIsEdit(value) {
  return async (dispatch) => {
    dispatch({
      type: types.USER_SET_IS_EDIT,
      payload: value,
    });
  };
}
